import {useNavigate} from "react-router-dom";
import {EditBundleFormValues} from "../types";
import {message} from "antd";
import {editBundleV2Dto} from "../edit-bundle-service";
import {useUpdateSession, Session} from "../../../../features/sessions";

interface HookResult {
  editBundle(values: EditBundleFormValues): void;
  wasBundleEdited: boolean;
  isEditingBundle: boolean;
  responseData?: Session;
}

export function useEditBundleHook(): HookResult {
  const navigate = useNavigate();
  const editSessionMutation = useUpdateSession();

  const editBundle = (values: EditBundleFormValues) => {
    const onSuccess = () => {
      message.success("Updated Successfully");
      navigate("/calls");
    };

    editSessionMutation.mutate(editBundleV2Dto(values), {onSuccess});
  };

  return {
    editBundle,
    wasBundleEdited: editSessionMutation.isSuccess,
    isEditingBundle: editSessionMutation.isPending,
    responseData: editSessionMutation.isSuccess ? editSessionMutation.data : undefined,
  };
}
